// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ec2cbc7","239":"f9268094","453":"a23d9e3f","455":"1a9c7829"}[chunkId] + ".chunk.js";
};